var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('PetitionIDInputDialog'),_c('ContactDialog',{attrs:{"modal_dialog":_vm.contact_dialog},on:{"close-dialog":function($event){_vm.contact_dialog = false}}}),_c('PageFooter',{attrs:{"contact_dialog":_vm.contact_dialog},on:{"open-dialog":function($event){_vm.contact_dialog = true}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }